import { inject, bindable, bindingMode } from 'aurelia-framework';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import * as noUiSlider from 'nouislider';

@inject(Element, EventAggregator)
export class Slider {

    private _subscriptions: Subscription[] = [];
    private _slider: any;
    
    constructor(
        public element: Element,
        private _eventBus: EventAggregator,
    ) {
    }

    @bindable({ defaultBindingMode: bindingMode.twoWay }) min: number;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) max: number;

    attached() {

        this.tryInitializeSlider();

        this._subscriptions = [
            this._eventBus.subscribe('reset-lrv', e => {
                this._slider.noUiSlider.set([0, 100]);
            })
        ];
    }

    detached() {
        this._subscriptions.forEach(s => s.dispose());
    }

    tryInitializeSlider() {
        if (this._slider)
            return;

        var slider = <any>this.element.querySelector('#slider');

        noUiSlider.create(slider, {
            start: [0, 100],
            connect: true,
            behaviour: 'drag',
            step: 10,
            margin: 10,
            range: {
                'min': 0,
                'max': 100
            }
        });

        slider.noUiSlider.on('update', (values, handle) => {
            if (handle == 0)
                this.min = parseFloat(values[handle]);
            else
                this.max = parseFloat(values[handle]);
        });

        this._slider = slider;
    }
}